import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcBedFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M19 10.447a2.75 2.75 0 0 1 2.75 2.75v6.053a.75.75 0 0 1-1.5 0v-2.303H3.75v2.303a.75.75 0 0 1-1.5 0v-6.053A2.75 2.75 0 0 1 5 10.447zM17.505 4.451a2.75 2.75 0 0 1 2.75 2.75v2.462A3.7 3.7 0 0 0 19 9.447h-1V8.7a1.5 1.5 0 0 0-1.5-1.5h-2.25a1.5 1.5 0 0 0-1.5 1.5v.748h-1.5V8.7a1.5 1.5 0 0 0-1.5-1.5H7.5A1.5 1.5 0 0 0 6 8.7v.748H5c-.436 0-.856.075-1.245.212V7.201a2.75 2.75 0 0 1 2.75-2.75z"
  }));
}
var IcBedFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcBedFill));

export { IcBedFill as I };
